import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { apiGet } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import DataTable from "../../DataTable";

export default function LeaderboardPOTYTable(props) {
  
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [onError, setOnError] = useState({ showAlert: false, msg: "" });

  // ==================>>> Retrieve Leaderboard data from API <<<==================

  const getLeaderboardData = () => {
    if (props.leagueInitialId == "") {
      // setIsLoading(false);
    } else {
      apiGet(
        `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}${
          ApiEndpoints.tournament.getcombinedleaderboard
        }${props.isInitial ? props.leagueInitialId : props.leagueId}`,
        (res) => {
          // console.log('response data getLeaderboardData ==> ', res)
          setLeaderboardData(res?.potyData);
          setIsLoading(false);
        },
        (err) => {
          console.error(err);
          setIsError(true);
          setOnError({ showAlert: true, msg: err.message });
        }
      );
    }
  };

  useEffect(() => {
    getLeaderboardData();
  }, [props.leagueInitialId, props.leagueId, props.isInitial]);

  const customStyles = {
    headRow: {
      style: {
        border: "1px solid #000000",
        borderRadius: 8,
      },
    },
    headCells: {
      style: {
        paddingLeft: "0px",
        paddingRight: "0px",
        marginLeft: "5px",
        justifyContent: "center",
        alignItems: "center",
      },
    },
    cells: {
      style: {
        justifyContent: "center",
        alignItems: "center",
      },
    },
    rows: {
      style: {
        border: "none !important",
        fontSize: "14px",
        fontWeight: "500",
        "&:nth-child(even)": {
          backgroundColor: "#F2F2F2",
        },
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.rank % 2 == 0,
      style: {
        backgroundColor: "#F2F2F2",
      },
    },
  ];

  const columns = [
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          Rank
        </Typography>
      ),
      // selector: (row, i) => {
      //   if (i < 9) {
      //     return `0${i + 1}`;
      //   } else {
      //     return `${i + 1}`;
      //   }
      // },
      selector: (row, i) => {
        return i + 1;
      },
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          Player Name
        </Typography>
      ),
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          Points
        </Typography>
      ),
      selector: (row) => row?.points,
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          Tournaments Played
        </Typography>
      ),
      selector: (row) => row?.tournaments_played,
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          FIR
        </Typography>
      ),
      selector: (row) => (row?.fir ? row?.fir : "-"),
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          GIR
        </Typography>
      ),
      selector: (row) => (row?.gir ? row?.gir : "-"),
      sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          fontWeight="700"
          fontSize={{ xs: "12px", md: "14px" }}
        >
          PPR
        </Typography>
      ),
      selector: (row) => (row?.putts ? row?.putts : "-"),
      sortable: true,
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <CircularProgress color="success" />
            <Typography mt={1}>Loading...</Typography>
          </Box>
        ) : isError ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#d10606",
                padding: 1,
                borderRadius: 1.2,
              }}
            >
              <ErrorIcon sx={{ color: "#FFF", margin: 1 }} />
              <Typography sx={{ color: "#FFF" }}>
                Error: {onError?.msg}
              </Typography>
            </Box>
          </Box>
        ) : (
          <DataTable
            columns={columns}
            data={leaderboardData}
            customStyles={customStyles}
            conditionalRowStyles={conditionalRowStyles}
            striped={true}
          />
        )}
      </Grid>

      <Snackbar
        open={onError?.showAlert}
        autoHideDuration={6000}
        onClose={() => setOnError({ ...onError, showAlert: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOnError({ ...onError, showAlert: false })}
          severity="error"
          sx={{ width: "100%" }}
        >
          {onError?.msg}
        </Alert>
      </Snackbar>
    </Grid>
  );
}
